import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { SslTool } from '@/components/tool-page/ssl-tool'
import { isCuratedDomain } from '@/lib/popular-sites'
import { domainPageContent, safeDomain } from '@/lib/tool-content'

const PARENT = { name: 'SSL Checker', path: '/tools/ssl-checker' }

export const Route = createFileRoute('/_site/tools/ssl-checker_/$domain')({
  component: SslCheckerDomainPage,
  // One indexing rule: a per-domain page is indexable only for a domain on the curated list.
  head: ({ params }) => {
    const d = safeDomain(params.domain)
    return toolHead(domainPageContent('ssl-checker', params.domain), { noindex: !(d && isCuratedDomain(d)), parent: PARENT })
  },
})

function SslCheckerDomainPage() {
  const { domain } = Route.useParams()
  const content = domainPageContent('ssl-checker', domain)
  return (
    <ToolPage content={content} parent={PARENT}>
      <SslTool content={content} initialHost={safeDomain(domain) ?? ''} autoRun />
    </ToolPage>
  )
}
